import { api, ReactQueryOptions, RouterInputs, RouterOutputs } from '@api';
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared';
import { TRPCClientErrorLike } from '@trpc/client';
type inputType = RouterInputs['ArtistManager']['getList'];
type queryOptionsType = ReactQueryOptions['ArtistManager']['getList'];
type outputType = RouterOutputs['ArtistManager']['getList'];
type optionsType = UseTRPCInfiniteQueryOptions<'ArtistManager.getList', inputType, outputType, TRPCClientErrorLike<any>>;
export const useGetArtistsInfiniteList = (input: inputType, options?: optionsType) => {
  return api.ArtistManager.getList.useInfiniteQuery(input, {
    ...options,
    queryKey: ['ArtistManager.getList', input],
    getNextPageParam: firstPage => firstPage.nextCursor,
    refetchOnWindowFocus: false,
    initialCursor: undefined,
    staleTime: 2 * 60 * 60 * 1000 // 2 hours
  });
};
export const useGetArtistsList = (input: inputType, options?: queryOptionsType) => {
  return api.ArtistManager.getList.useQuery(input, {
    ...options,
    queryKey: ['ArtistManager.getList', input],
    staleTime: 2 * 60 * 60 * 1000 // 2 hours
  });
};